// Colormap stop definitions loaded from data/colormaps/. Read by
// physics/colormap to sample colours.

import type { ColormapDefs } from '../../physics/types';

export interface ColormapState {
    defs: ColormapDefs;
}

export function createColormapState(): ColormapState {
    return { defs: {} };
}
